import moment from 'moment';

import { TaskForCalendarAssignment, TimelineItem } from '../../types/interfaces';

export function computeTasksByDay(args: {
  employeesTasks: Record<string, TaskForCalendarAssignment[]>;
  computeTaskInterval: (task: TaskForCalendarAssignment) => {
    start: moment.Moment;
    end: moment.Moment;
  };
}) {
  const { employeesTasks, computeTaskInterval } = args;

  const map: Record<
    string,
    Record<string, { count: number; tasks: TaskForCalendarAssignment[] }>
  > = {};

  Object.entries(employeesTasks).forEach(([personIdStr, tasks]) => {
    const personMap: Record<
      string,
      { count: number; tasks: TaskForCalendarAssignment[] }
    > = {};
    tasks.forEach((task) => {
      const { start, end } = computeTaskInterval(task);
      const current = moment(start).clone().startOf('day');
      const endDay = moment(end).startOf('day');
      while (current.isSameOrBefore(endDay)) {
        const dayStr = current.format('YYYY-MM-DD');
        if (!personMap[dayStr]) {
          personMap[dayStr] = { count: 0, tasks: [] };
        }
        if (current.isSame(start, 'day') || task.factFinish || task.planFinish) {
          personMap[dayStr].count++;
          personMap[dayStr].tasks.push(task);
        }
        current.add(1, 'day');
      }
    });
    map[personIdStr] = personMap;
  });

  return map;
}

export function buildTaskItems(args: {
  employeesTasks: Record<string, TaskForCalendarAssignment[]>;
  showNotClosed: boolean;
  showClosed: boolean;
}): TimelineItem[] {
  const { employeesTasks, showNotClosed, showClosed } = args;

  if (!showNotClosed && !showClosed) return [];

  const items: TimelineItem[] = [];

  Object.entries(employeesTasks).forEach(([personId, tasks]) => {
    let filteredTasks = tasks;

    if (showNotClosed && showClosed) {
      filteredTasks = tasks;
    } else if (showNotClosed) {
      filteredTasks = tasks.filter((task) => !task.isClosed);
    } else if (showClosed) {
      filteredTasks = tasks.filter((task) => task.isClosed);
    }
    if (filteredTasks.length === 0) return;

    const employeeTasks = filteredTasks.map((task) => {
      const start = moment(task.factStart ?? task.planStart ?? task.creationTime);
      let end: moment.Moment;
      let cutRight = false;

      if (task.factFinish) {
        end = moment(task.factFinish);
      } else if (task.planFinish) {
        end = moment(task.planFinish);
      } else {
        end = start.clone().endOf('day').subtract(2, 'hours');
        cutRight = true;
      }

      const duration = end.valueOf() - start.valueOf();

      return {
          id: `${task.personId}-task-${task.id}`,
          group: Number(personId),
          title: `${task.taskType?.label} #${task.id}`,
          start_time: start.valueOf(),
          end_time: end.valueOf(),
          duration,
          className: `task-item${task.isClosed ? ' is-closed' : ''}${cutRight ? ' cut-right' : ''}`,
          originalTask: task,
          cutRight
      };
    });

    employeeTasks.sort((a, b) => a.duration - b.duration);

    employeeTasks.forEach((task, index) => {
      const zIndex = 80 + (employeeTasks.length - index);

      items.push({
        id: task.id,
        group: task.group,
        title: task.title,
        start_time: task.start_time,
        end_time: task.end_time,
        className: task.className,
        itemProps: {
          style: {
            // TODO уточнить у алексея
            // backgroundColor: task.originalTask.factFinish ? 'lightgreen' : 'lightblue',
            backgroundColor: 'lightblue',
            borderRadius: 4,
            color: '#000',
            top: 0,
            zIndex: zIndex
          }
        }
      } as any);
    });
  });

  return items;
}

